import request from "@/utils/request";  //导入封装请求的js文件

// 查询使用手册详细
export function getAssist(id) {
    return request({
        url: '/memberApi/assist/' + id,
        method: 'get'
    })
}